export default __webpack_public_path__ + "static/media/4C8AD983-32CA-472B-94AE-883E6CFD9AFE_4_5005_c.c6682e21.jpeg";